module.exports = __webpack_public_path__ + "static/media/arrow-left.7af449f5.svg";